import { type FC } from 'react'
import pluralize from 'pluralize'
import { type BulkSeatPreview } from './bulkSeatPreview'
import { requestedLine } from './bulkSummaryCopy'

export interface BulkInviteSummaryProps {
  preview: BulkSeatPreview
  canBuy: boolean
}

export const BulkInviteSummary: FC<BulkInviteSummaryProps> = ({ preview, canBuy }) => {
  const seatsLeft = preview.general.left + preview.sidecar.left
  const usedLines = [
    { word: 'advisor', count: preview.general.used },
    { word: 'assistant', count: preview.sidecar.used },
  ].filter((line) => line.count > 0)
  const shortageLines = [
    { word: 'advisor', count: preview.general.shortage },
    { word: 'assistant', count: preview.sidecar.shortage },
  ].filter((line) => line.count > 0)
  const shortageTotal = shortageLines.reduce((sum, line) => sum + line.count, 0)

  return (
    <div className='d-flex gap-2 align-items-start rounded-2 zocks-bg-color-gray-100 border zocks-border-color-gray-300 px-3 py-4'>
      <i className='bi bi-info-circle zocks-text-gray-600 flex-shrink-0' />
      <div className='d-flex flex-column gap-3 paragraph-small zocks-text-gray-600'>
        <div>
          <div className='bold'>
            {seatsLeft} {pluralize('seat', seatsLeft)} left after these invitations
          </div>
          {usedLines.map((line) => (
            <div key={line.word}>
              {line.count} {line.word} {pluralize('seat', line.count)} will be used.
            </div>
          ))}
        </div>
        {shortageTotal > 0 ? (
          <div>
            {shortageLines.map((line) => (
              <div key={line.word} className='bold'>
                {line.count} {pluralize('invitation', line.count)} {line.count === 1 ? 'needs' : 'need'} an {line.word} seat, and none are available.
              </div>
            ))}
            <div>{requestedLine(canBuy, shortageTotal)}</div>
          </div>
        ) : null}
      </div>
    </div>
  )
}
